/**
 * State for clients
 */
export const state = {
  /**
   * Weather data has been loaded for any provider
   *
   * Format {
   *   3159: true
   * }
   */
  dataLoaded: {},

  /**
   * Weather data is being loaded
   */
  loading: false,

  /**
   * All the clients of the user keyed by provider id,
   *
   * Format
   * {
   *   [provider_id]: {
   *      id:3204, // The client id
   *     birthDate:"2019-08-01", // The birth date of the client
   *     email1:"rakeshranjan.phoenix+1123@gmail.com", // Email 1 of the client
   *     email2:"", // Email 2 of the client
   *     favourite_id:150, // Favourite id of the client
   *     firstName:"1", // First name of the client
   *     lastName:"12", // Last name of the client
   *     middleName:"", // Middle name of the client
   *     namePrefix:"", // Name prefix of the client
   *     nameSuffix:"", // Name suffix of the client
   *     noteId:null, // Note id
   *     notes:null, // Note if any
   *     pha_city:"", // Address city
   *     pha_line1:"", // Address line 1
   *     pha_line2:"", // Address line 2
   *     pha_postalCode:"", // Address postal code
   *     pha_state:"", // Address state
   *     phone1:"912-459-4437", // Phone 1
   *     phone2:"912-459-4437", // Phone 2
   *     phone3:"987-654-3321", // Phone 3
   *     phone4:"", // Phone 4
   *     pht1:"", // Phone type 1
   *     pht2:"", // Phone type 2
   *     pht3:"", // Phone type 3
   *     pht4:"", // Phone type 4
   *     providerID:3159, // Provider id
   *     selected_phone:null, // Selected phone
   *     status:1, // Status of the client, Active(0), Archived(1)
   *     timezone:"America/New_York", // Time zone
   *     userID:null // If portal id is present, this won't be null
   *   }[]
   * }
   */
  clients: {},

  /**
   * To check if we need to show active clients or archived clients
   */
  active: true, //

  /**
   * Weather to open add client in add mode or edit mode
   */
  mode: "ADD",

  /**
   * The id of the client that is to be edit
   */
  editClientId: 0
};
